import React, {Component} from 'react';
import {Button, Header, Loader, Menu, Message, Table} from 'semantic-ui-react';
import moment from "moment";
import connect from "react-redux/es/connect/connect";
import {FormattedNumber} from "react-intl";
import DynamicTableData from "../../data/DynamicTableData";
import {simpleTableList} from "../../actions/SimpleTableDataActions";


class SimpleTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            table: props,
            loading: true,
            search: '',
            id: props.id,
            data: []
        };
    }

    componentWillMount() {
        this.loadData('', 1);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.data.id === this.state.id) {
            this.setState({data: nextProps.data.data})
        }

        if(nextProps.data.id === this.state.id && nextProps.url !== this.state.table.url){
            this.setState({data: nextProps});
            this.reloadData(nextProps);
        }else{
            this.reloadData(nextProps);
        }
    }

    loadData = () => {
        this.setState({loading: true});
        DynamicTableData.list(this.props.url, '', 1).then(data => {
            this.props.simpleTableList({data, id: this.props.id});
            if(this.props.return_data){
                this.returnData(data);
            }
        }).catch(() => {
            this.props.simpleTableList({data: []});
        }).finally(() => {
            this.setState({loading: false});
        });
    };

    returnData = (data) => {
        this.props.callbackReturnData(data);
    };

    reloadData = (table) => {
        this.setState({loading: true});
        DynamicTableData.list(table.url, '', 1).then(data => {
            if(this.props.return_data){
                this.returnData(data);
            }
            this.setState({data, loading: false});
        }).catch(() => {
            this.setState({data:[], loading: false});
        });
    };

    cellType = (value, key, data) => {
        if (this.state.table.money_fields && this.state.table.money_fields.includes(key)) {
            // eslint-disable-next-line
            return <FormattedNumber value={value} currency="USD" style="currency" maximumFractionDigits={1}
                                    minimumFractionDigits={1}/>;
        } else if (this.state.table.datetime_fields && this.state.table.datetime_fields.includes(key)) {
            return moment(value).format('M/DD/YYYY - h:mm A');
        } else if (this.state.table.date_fields && this.state.table.date_fields.includes(key)) {
            return moment(value).format('M/DD/YYYY');
        } else if (this.state.table.boolean_fields && this.state.table.boolean_fields.includes(key)) {
            return value ? 'Si' : 'No';
        } else if (this.state.table.child_fields && this.state.table.child_fields[0].hasOwnProperty(key) && value) {
            return value[this.state.table.child_fields[0][key]];
        } else if (this.state.table.component_fields && this.state.table.component_fields[0].hasOwnProperty(key)) {
            const ComponentField = this.state.table.component_fields[0][key];
            return <ComponentField {...data}/>;
        } else if (this.state.table.percentage_fields && this.state.table.percentage_fields.includes(key)) {
            return `${value}%`;
        } else {
            return !!value ? value : '_';
        }
    };

    render() {
        return (
            <Table striped>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell colSpan={this.state.table.headers.length}>
                            <Menu secondary>
                                <Menu.Item>
                                    <Header as='h2'>
                                        <Header.Content>
                                            {this.state.table.title}
                                        </Header.Content>
                                    </Header>
                                </Menu.Item>
                            </Menu>
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Header>
                    <Table.Row>
                        {
                            this.state.table.headers.map((header, index) => {
                                return <Table.HeaderCell key={index}>{header}</Table.HeaderCell>
                            })
                        }
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {this.state.loading ? <Table.Row>
                            <Table.Cell colSpan={this.state.table.headers.length}>
                                <Loader active inline='centered'>Cargando</Loader>
                            </Table.Cell>
                        </Table.Row> :
                        this.state.data.map(data => {
                            let keys = Object.keys(data);
                            let rows = keys.map((key, index) => {
                                if (this.state.table.values.includes(key) && key !== 'id') {
                                    return <Table.Cell key={index}>
                                        {this.cellType(data[key], key, data)}
                                    </Table.Cell>
                                } else {
                                    return null;
                                }
                            });
                            if (this.state.table.has_actions) {
                                rows.push(
                                    <Table.Cell key='100000'>
                                        <Button.Group basic size='small'>
                                            {this.state.table.edit ? <Button icon='pencil'
                                                                             onClick={() => this.props.callbackDynamicTable({
                                                                                 event: 'edit',
                                                                                 data
                                                                             })}/> : null}
                                            {this.state.table.delete ? <Button icon='trash'
                                                                               onClick={() => this.props.callbackDynamicTable({
                                                                                   event: 'delete',
                                                                                   data
                                                                               })}/> : null}
                                            {this.state.table.images ? <Button icon='image'
                                                                               onClick={() => this.props.callbackDynamicTable({
                                                                                   event: 'images',
                                                                                   data
                                                                               })}/> : null}
                                            {this.state.table.navigate ? <Button icon='angle right'
                                                                                 onClick={() => this.props.callbackDynamicTable({
                                                                                     event: 'navigate',
                                                                                     data
                                                                                 })}/> : null}
                                            {this.state.table.user ? <Button icon='user'/> : null}
                                        </Button.Group>
                                    </Table.Cell>
                                );
                            }
                            return <Table.Row key={data.id}>
                                {rows}
                            </Table.Row>
                        })}
                    {
                        this.state.data <= 0 && !this.state.loading ? <Table.Row>
                            <Table.Cell
                                colSpan={this.state.table.headers.length}>
                                <Message
                                    icon='frown outline'
                                    header='No hay resultados'
                                />
                            </Table.Cell>
                        </Table.Row> : null
                    }
                </Table.Body>
            </Table>
        );
    }
}

const mapStateToProps = state => {
    return {
        data: state.get('simple_table_data'),
    };
};

function mapDispatchToProps(dispatch) {
    return {
        simpleTableList(data) {
            dispatch(simpleTableList(data))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SimpleTable)



// WEBPACK FOOTER //
// ./src/components/extras/SimpleTable.js